import React, { useState } from 'react';
import type { Meta, StoryObj } from '@storybook/react';
import IconSearch from '@cimpress-technology/react-streamline-icons/lib/IconSearch';
import { TextField, TextFieldProps } from '../TextInput';
import { Button } from '../Button';

const meta: Meta<typeof TextField> = {
  title: 'Components/TextField',
  component: TextField,
};

export default meta;
type Story = StoryObj<typeof TextField>;

function TextFieldStory(props: Omit<TextFieldProps, 'onChange'>) {
  const [value, setValue] = useState('');

  return (
    <TextField
      {...props}
      value={value}
      onChange={e => {
        setValue(e.currentTarget.value);
      }}
    />
  );
}

export const Default: Story = {
  args: {
    label: 'First name',
  },
  render: TextFieldStory,
};

export const Required: Story = {
  args: {
    label: 'First name',
    required: true,
  },
  render: TextFieldStory,
};

export const Status: Story = {
  args: {
    label: 'First name',
    status: 'error',
  },
  render: TextFieldStory,
};

export const Addon: Story = {
  args: {
    label: 'First name',
    rightAddon: <Button>Button</Button>,
  },
  render: TextFieldStory,
};

export const MultipleAddons: Story = {
  args: {
    label: 'First name',
    status: 'error',
    rightAddon: (
      <>
        <Button>Foo</Button>
        <Button>Bar</Button>
        <Button icon={<IconSearch />} />
      </>
    ),
  },
  render: TextFieldStory,
};

export const FormIntegration: Story = {
  render() {
    return (
      <form
        onSubmit={e => {
          e.preventDefault();
        }}
      >
        <TextField label="First name" minLength={3} pattern="[A-Z]{1}[a-z]+" />
        <Button type="submit">Submit</Button>
      </form>
    );
  },
};
